import { render, staticRenderFns } from "./format-ticket.html?vue&type=template&id=2c3ca9ce&scoped=true&external"
import script from "./format-ticket.js?vue&type=script&lang=js&external"
export * from "./format-ticket.js?vue&type=script&lang=js&external"
import style0 from "./format-ticket.scss?vue&type=style&index=0&id=2c3ca9ce&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c3ca9ce",
  null
  
)

export default component.exports